import { render, staticRenderFns } from "./controlo_actividades.vue?vue&type=template&id=1bfb0ee6&"
import script from "./controlo_actividades.vue?vue&type=script&lang=js&"
export * from "./controlo_actividades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports